import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Preloader from './components/Preloader';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import BookACar from './pages/BookACar';
import CarDetail from './pages/CarDetail';
import CarList from './pages/CarList';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

// Layout component with Header and Footer
const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Preloader />
      <div id="wrapper">
        <div id="page" className="clearfix">
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} exact />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/book-a-car" element={<BookACar />} />
              <Route path="/car-list" element={<CarList />} />
              <Route path="/:carSlug" element={<CarDetail />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
